import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

const DAYS = 30;

export default function WolfName({ wolf, refresh }) {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(wolf.name);
  const [busy, setBusy] = useState(false);
  const next = wolf.renamed_at ? new Date(new Date(wolf.renamed_at).getTime() + DAYS * 864e5) : null;
  const locked = next && next > new Date();
  const save = async () => {
    const n = name.trim().replace(/\s+/g, " ");
    if (n.length < 2 || n.length > 20) return toast.error("Names are 2 to 20 characters");
    if (n !== wolf.name && !window.confirm(`Rename your wolf to "${n}"? You can only change it once every ${DAYS} days.`)) return;
    setBusy(true);
    try { await api.post("/game/wolf/name", { name: n }); await refresh(); toast.success("Name updated"); setEdit(false); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (edit) return (
    <div className="mb-2" data-testid="wolf-name-edit">
      <div className="flex gap-2">
        <Input data-testid="wolf-name-input" value={name} maxLength={20} autoFocus onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} className="bg-slate-950 h-10" />
        <button data-testid="wolf-name-save" disabled={busy} onClick={save} aria-label="Save name" className="px-3 rounded-lg border border-emerald-400/60 text-emerald-200 hover:bg-emerald-500/10 disabled:opacity-40"><Check className="w-4 h-4" /></button>
        <button data-testid="wolf-name-cancel" onClick={() => { setEdit(false); setName(wolf.name); }} aria-label="Cancel" className="px-3 rounded-lg border border-slate-600 text-slate-300 hover:border-slate-400"><X className="w-4 h-4" /></button>
      </div>
      <p className="text-[11px] text-slate-500 mt-1">Letters, numbers, spaces and _ ' . - only. Must be unique. Once every {DAYS} days.</p>
    </div>
  );
  return (
    <div className="flex items-center gap-2 mb-1">
      <h1 className="font-display text-3xl text-amber-100" data-testid="profile-wolf-name">{wolf.name}</h1>
      {locked ? <span className="text-[11px] text-slate-500" data-testid="wolf-name-locked">Rename from {next.toLocaleDateString()}</span>
        : <button data-testid="wolf-name-edit-btn" onClick={() => setEdit(true)} aria-label="Edit wolf name" className="p-1.5 rounded-full text-slate-400 hover:text-amber-200 hover:bg-amber-500/10 transition-colors"><Pencil className="w-4 h-4" /></button>}
    </div>
  );
}
